"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactHelmet = require("react-helmet");

var _address = _interopRequireDefault(require("./transformers/address"));

var _openingHours = _interopRequireDefault(require("./transformers/openingHours"));

var _proptypes = require("./proptypes");

var LocalBusinessSchema = function LocalBusinessSchema(_ref) {
  var siteUrl = _ref.siteUrl,
      images = _ref.images,
      name = _ref.name,
      logo = _ref.logo,
      address = _ref.address;
  var featuredImage = images.length > 0 ? images[0] : null;
  var data = {
    '@context': 'http://schema.org',
    '@type': 'LocalBusiness',
    name: name,
    url: siteUrl,
    logo: logo,
    image: featuredImage,
    address: (0, _address["default"])(address)
  };
  return /*#__PURE__*/_react["default"].createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react["default"].createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify(data)));
};

var _default = LocalBusinessSchema;
exports["default"] = _default;
LocalBusinessSchema.propTypes = {
  siteUrl: _propTypes["default"].string,
  images: _propTypes["default"].arrayOf(_propTypes["default"].string),
  name: _propTypes["default"].string.isRequired,
  logo: _propTypes["default"].string,
  address: _propTypes["default"].oneOfType([_propTypes["default"].string, _proptypes.LocationPropType, _propTypes["default"].arrayOf(_proptypes.LocationPropType)])
};
LocalBusinessSchema.defaultProps = {
  siteUrl: null,
  images: [],
  logo: '',
  address: ''
};